<!-- eslint-disable -->
<template>
  <Fragment>
    <div v-if="!loaded" class="loading">
<i class="fas fa-circle-notch fa-spin" />
</div>
    <JobDetail
v-if="loaded === true && isExpired === false"
:id="id"
:wrapper="wrapper"
:show-new-tab="showNewTab"
:show-predict="true"
      :ssr-data="ssrData"
:preview="preview"
:disabled="disabled"
 />
    <ExpiredJobCard v-if="isExpired" :notAvailable="notAvailable" />
  </Fragment>
</template>

<script>
import {
  Fragment
} from 'vue-fragment'
import JobDetail from './jd/JobDetail'
import ExpiredJobCard from './jd/ExpiredJobCard'
export default {
  components: {
    JobDetail,
    ExpiredJobCard,
    Fragment
  },
  props: {
    id: {
      default: null,
      type: String
    },
    pad: {
      default: 0,
      type: Number
    },
    wrapper: {
      default: null,
      type: String
    },
    showNewTab: {
      default: true,
      type: Boolean
    },
    closePreview: {
      default: null,
      type: Function
    },
    showPredict: {
      default: true,
      type: Boolean
    },
    closable: {
      default: false,
      type: Boolean
    },
    preview: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    ssrData: {
      default: null,
      type: Object
    }
  },
  data: function () {
    return {
      loaded: false,
      isExpired: false,
      notAvailable: false
    }
  },
  async mounted() {
    if (!this.ssrData) {
      await this.$store.dispatch('jobs/fetchDetail', this.id)
      this.loaded = true
      await this.$store.dispatch('jobs/fetchCompany', this.id)
      this.jobResult = await this.$store.state.jobs.detail
      this.companyResult = await this.$store.state.jobs.company
      this.cdata = await this.$store.state.jobs.companyOther
      this.isExpired = this.jobResult.expired
      this.notAvailable = this.jobResult.notAvailable
    } else {
      const { jobResult, companyResult, cdata } = this.ssrData
      this.jobResult = jobResult
      this.loaded = true
      this.companyResult = companyResult
      this.cdata = cdata
      this.isExpired = jobResult.expired
      this.notAvailable = jobResult.notAvailable
    }
    // for IT-34 add viewed call
    if (!this.disabled) {
      const headers = { 'Content-Type': 'application/json' }
      this.$axios.put('statistic/' + this.id + '/view', { headers: headers })
    }
  }
}

</script>

<style>
.loading{
    text-align: center;
    font-size: 40px;
    margin-top: 45%;
}
</style>
